import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { H2 } from 'UIComponents/elements/headings';
import { getStepTitle } from '../utils/getStepTitle';
import { Step } from '../views/Step';
import { OptionalFormattedMessage } from './OptionalFormattedMessage';
import { TitleTooltip } from './TitleTooltip';
const StyledStepTitle = styled(H2).withConfig({
  displayName: "StepTitle__StyledStepTitle",
  componentId: "we7w67-0"
})(["font-size:2rem;font-weight:700;", " ", ""], props => (props.stepKey === Step.ExistingUser || props.stepKey === Step.Verification || props.stepKey === Step.CodeVerification) && `text-align: center;`, props => props.theme.embedded && `margin-top: 20px;
  text-align: center;
  font-size: 1.75rem;`);
export const StepTitle = (_ref) => {
  let {
    hasTooltip = false,
    stepKey,
    message = null,
    className = '',
    children,
    tooltipLink,
    shouldShowDefault = true
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["hasTooltip", "stepKey", "message", "className", "children", "tooltipLink", "shouldShowDefault"]);

  const title = useSelector(getStepTitle);
  const classNames = `${stepKey} ${className}`;
  return /*#__PURE__*/_jsxs(StyledStepTitle, Object.assign({
    className: classNames,
    stepKey: stepKey
  }, rest, {
    children: [shouldShowDefault && /*#__PURE__*/_jsx(OptionalFormattedMessage, {
      message: message || title
    }), hasTooltip && stepKey && tooltipLink && /*#__PURE__*/_jsx(TitleTooltip, {
      stepKey: stepKey,
      tooltipLink: tooltipLink
    }), children]
  }));
};